/* eslint-disable import/no-default-export */
import ReactDOM from 'react-dom';

export default function singleItemHoldRequestLauncher({
    environment,
    itemId,
    transactionId,
    userId,
    onError,
    onSuccess,
    linkLocation,
}) {
    const modalContainer = document.createElement('div');
    import(
        /* webpackChunkName: "holdRequestModal" */
        '../src/HoldRequestModal/SingleItemHoldRequest'
    ).then(mod => {
        const { components, helpers } = mod;

        const { SingleItemHoldRequest, IntlProvider } = components;
        const { serverVars } = helpers;

        const rendererProps = {
            environment,
            itemId,
            transactionId,
            userId,
            onError,
            onSuccess,
            linkLocation,
        };

        ReactDOM.render(
            <IntlProvider locale={serverVars.get('locale')} messages={serverVars.get('messages')}>
                <SingleItemHoldRequest {...rendererProps} openOnRender />
            </IntlProvider>,
            modalContainer
        );
    });
}
